import { render, staticRenderFns } from "./ContentMenu.vue?vue&type=template&id=18b35879&"
import script from "./ContentMenu.vue?vue&type=script&lang=js&"
export * from "./ContentMenu.vue?vue&type=script&lang=js&"
import style0 from "./ContentMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports